import { Routes, Route, Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStores } from "./use.store";
import HomePage from "./pages/HomePage";
import SplashPage from "./pages/SplashPage";
import HighlightPage from "./pages/HighlightPage";
import WayfinderPage from "./pages/WayfinderPage";
import ResourcesPage from "./pages/ResourcesPage";
import GeneralEnquiriesPage from "./pages/GeneralEnquiriesPage";
import VoiceCallInterface from "./components/VoiceCallInterface";
import CustomerServiceChatPage from "./pages/CustomerServiceChatPage";
import FeedbackPage from "./pages/FeedbackPage";

const App = () => {
  const { mainStore } = useStores();

  return !mainStore.appLoaded ? (
    <SplashPage />
  ) : (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* <Route path="/highlights" element={<HighlightPage />} /> */}
      {/* <Route path="/wayfinder" element={<WayfinderPage />} /> */}
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/general-enquiries" element={<GeneralEnquiriesPage />} />
      <Route
        path="/chat-customer-service"
        element={<CustomerServiceChatPage />}
      />
      <Route path="/call" element={<VoiceCallInterface />} />
      <Route path="/feedback-page" element={<FeedbackPage />} />
    </Routes>
  );
};

export default observer(App);
